"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavBarContext = exports.NavBarContext = void 0;
var _react = require("react");
const NavBarContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.NavBarContext = NavBarContext;
const useNavBarContext = () => {
  const data = (0, _react.useContext)(NavBarContext);
  if (!data) {
    throw new Error("useNavBarContext must be used within a NavBar component");
  }
  return data;
};
exports.useNavBarContext = useNavBarContext;